import { DateObject } from 'react-multi-date-picker';
import persian from 'react-date-object/calendars/persian';
import persianLocale from 'react-date-object/locales/persian_fa';

const timestampToJalali = (timestamp) => {
  const dateObject = new DateObject({
    date: timestamp * 1000,
    calendar: persian,
    locale: persianLocale
  });

  return dateObject.format('YYYY/MM/DD');
};


export {timestampToJalali}